import * as React from 'react';
import { CSSProperties } from 'react';
import styled from 'styled-components';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { Colors, hideOutline, IThemeProps, safeInvoke } from '../common';
import { Avatar } from '../person/Avatar';
import { MunikumIcons } from '../common/icons';
import { Popover } from '../basic/Popover/Popover';
import { MunikumKeys } from '../common/keys';
import {
  H3,
  TextNormal,
  TextSmall,
  TextVerySmall,
} from '../basic/Structural/typography';
import { FlexDiv } from '../layout/Page/Page';
import {
  MAKE_SHARABLE,
  REMOVE_SHARABLE,
} from '../../containers/AnnualCycle/calendar-queries';
import { myApolloClient } from '../../graphql/apolloClientFactory';
import { CleanDialog, CloseWarningOption } from '../basic/Dialog/CleanDialog';
import { Button, ButtonTheme } from '../basic';
import { Toaster } from '../basic/Toaster/Toaster';
import { ToastType } from '../basic/Toaster/Toast';
import { commonMessages } from '../language/commonMessages';
import { FormErrorMessage } from '../topics/TopicForm';
import { CALENDAR_SHARE_HOST } from '../../index';

export enum typeToList {
  ORGANIZATIONS = 'ORGANIZATIONS',
  PERSONS = 'PERSONS',
  ORGANIZATIONGROUPS = 'ORGANIZATIONGROUPS',
  PERSONGROUPS = 'PERSONGROUPS',
}

export const MemmbersContainer = styled.div`
  display: flex;
  border-radius: 3px;
  box-sizing: border-box;
  background-color: ${props => props.theme.contentBackgroundColor};
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid ${props => props.theme.noAccent.borderColor};
  padding: 0.5em;
  overflow: hidden;
  flex-direction: row;
  justify-content: space-between;
  overflow-wrap: break-word;
  word-break: break-word; /* Chrome, Safari */
  word-wrap: break-word; /* IE11, Firefox */
  transition: box-shadow 0.2s ease-in-out;
  height: 40px;
  margin-bottom: 0.25em;
`;

const NameDiv = styled.div`
  width: 122px;
  color: ${props => props.theme.textColor};
  font-size: 14px;
  overflow: hidden;
  margin-left: 1em;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const ImgContainer = styled.div`
  display: flex;
  //background-color: #8b9898;
  flex: 0 0 32%;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba(51, 51, 51, 0.7);
  font-family: Lato, sans-serif;
  font-size: 12px;
  //height: 36px;
  align-items: center;
`;

const OrganizationDiv = styled.div`
  color: ${props => props.theme.textColor};
  font-family: Lato, sans-serif;
  font-size: 12px;
  max-width: 120px;
  margin-left: 1em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const PermissionCont = styled.div`
  display: flex;
  color: ${props => props.theme.textColor};
  font-family: Lato, sans-serif;
  font-size: 12px;
  line-height: 15px;
  align-items: center;
  justify-content: flex-start;

  :hover {
    cursor: ${(props: { canChangePermission: boolean }) =>
            props.canChangePermission ? 'pointer' : 'default'};
  }
`;

const RemoveDiv = styled.div`
  display: ${(props: { canRemove: boolean }) =>
          props.canRemove ? 'flex' : 'none'};
  transition: all 0.2s ease-in-out;
  width: 1.6em;
  height: 1.6em;
  justify-content: flex-end;
  align-items: center;

  :hover {
    transform: scale(1.1);
    cursor: pointer;
  }
`;
export const PermissionList = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props: { isActive: boolean; theme: IThemeProps }) =>
          props.isActive
                  ? props.theme.accent2.color
                  : props.theme.secondaryContentBackgroundColor};

  border-bottom: 1px solid ${(props: { isActive: boolean; theme: IThemeProps }) =>
          props.theme.textColor};
  color: ${(props: { isActive: boolean; theme: IThemeProps }) =>
          props.theme.textColor};
  font-size: 14px;
  margin: 8px;

  &:hover {
    cursor: pointer;
  }
`;

const SharableUriCont = styled(MemmbersContainer)`
  max-width: ${(props: { isEditing: boolean; theme: IThemeProps }) =>
          props.isEditing ? '100%' : 'max-content'};
  align-items: center;
  justify-content: ${(props: { isEditing: boolean; theme: IThemeProps }) =>
          props.isEditing ? 'space-between' : 'flex-start'};
  transition: ease-in-out 0.2s;
  box-shadow: none;

  :hover {
    cursor: ${(props: { isEditing: boolean; theme: IThemeProps }) =>
            props.isEditing ? 'default' : 'pointer'};
    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
  }
`;
const Temp = styled.div`
  border: none;

  text-decoration: underline;
  font-size: 12px;
  margin-right: 0.2em;
  font-weight: bold;
  ${hideOutline()};
`;
const OverlayDiv = styled.div`
  border-radius: 3px;
  background-color: ${props => props.theme.tertiaryContentBackgroundColor};
  padding: 1em;
  display: flex;
  height: 10em;
  width: 18em;
  flex-direction: column;
  justify-content: space-between;
`;

const IconDiv = styled(TextVerySmall)`
  transition: ease-in-out 0.2s;

  :hover {
    cursor: pointer;
    transform: scale(1.1);
  }
`;
const Input = styled.input`
  border: 1px solid ${props => props.theme.noAccent.borderColor};
  border-radius: 3px;
  height: 2em;
  padding: 0.5em;
  box-sizing: border-box;
  ${hideOutline()};
  color: ${props => props.theme.textColor};
  background-color: ${props => props.theme.secondaryContentBackgroundColor};
`;
const CopyDiv = styled(FlexDiv)`
  :hover {
    cursor: pointer;
  }
`;

interface IProps {
  name: string;
  disabled?: boolean;
  organization?: any;
  department?: any;
  role?: any;
  onChangeSelected?: (selectedKey: string) => void;
  permissionLevel: { value: string; name: string };
  handleRemoveMember: () => void;
  img: any;
  canRemove: boolean;
  leftImg?: any;
  profilePic?: string | null;
  type: typeToList;
  canChangePermission: boolean;
  onBlur?: React.FormEventHandler<HTMLElement>;
}

interface IMembersOfAnnualCycleCardCompState {
  isPermissionPopoverOpen: boolean;
  currentIndex: number;
}

let permissionList: Array<any> = [
  { value: 'READ', name: 'Lese' },
  { value: 'WRITE', name: 'Skrive' },
];

class MembersOfAnnualCycleCardComp extends React.PureComponent<
  IProps & InjectedIntlProps,
  IMembersOfAnnualCycleCardCompState
> {
  constructor(props: IProps & InjectedIntlProps) {
    super(props);

    this.state = {
      isPermissionPopoverOpen: false,
      currentIndex: -1,
    };
  }

  protected handleKeyUp = (e: any) => {
    if (e.which === MunikumKeys.ARROW_UP) {
      if (this.state.currentIndex > 0) {
        this.setState({
          currentIndex: this.state.currentIndex - 1,
        });
      }
    } else if (e.which === MunikumKeys.ARROW_DOWN) {
      if (this.state.currentIndex < permissionList.length - 1) {
        this.setState({
          currentIndex: this.state.currentIndex + 1,
        });
      }
    }

    // else if (e.which === MunikumKeys.ENTER) {
    //   if(this.props.canChangePermission) {
    //     const selectedItem = permissionList[this.state.currentIndex].value;
    //     safeInvoke(this.props.onChangeSelected, selectedItem);
    //     console.log(selectedItem, 'selecteditem');
    //     this.setState({
    //       isPermissionPopoverOpen: false,
    //       currentIndex: -1,
    //     });
    //   }
    // }
  };
  // componentDidMount() {
  //   document.addEventListener('keyup', this.handleKeyUp);
  // }
  //
  // componentWillUnmount() {
  //   document.removeEventListener('keyup', this.handleKeyUp);
  // }
  // const handleChange = (e: any) => {
  //   safeInvoke(p.onChangeSelected, e.target.value);
  // };
  render() {
    // console.log(this.props.img);
    const { onBlur } = this.props;
    let profilePic: string | undefined = undefined;
    if (this.props.profilePic) {
      profilePic = 'https://hel1.your-objectstorage.com/munikum-public/' + this.props.profilePic;
    }
    return (
      <MemmbersContainer key={''}>
        <ImgContainer>
          {profilePic && this.props.type === typeToList.PERSONS && (
            <img
              style={{
                borderRadius: '50%',
                flex: ' 0 0 25px',
              }}
              src={profilePic}
              width="25px"
              height="25px"
              alt={''}
            />
          )}
          {this.props.type === typeToList.ORGANIZATIONS && this.props.img}
          {this.props.type === typeToList.PERSONGROUPS && (
            <MunikumIcons.Topic
              style={{
                width: '1.875em',
                height: '1.875em',
              }}
            />
          )}
          {this.props.type === typeToList.ORGANIZATIONGROUPS && (
            <MunikumIcons.KostraEducation
              style={{
                width: '1.875em',
                height: '1.875em',
              }}
            />
          )}
          {!profilePic && this.props.type === typeToList.PERSONS && (
            <Avatar style={{ flex: ' 0 0 1.875em' }} name={this.props.name} />
          )}

          <NameDiv> {this.props.name}</NameDiv>
        </ImgContainer>
        {this.props.type === typeToList.PERSONS && (
          <ImgContainer style={{ marginLeft: '1.8em' }}>
            {this.props.img}
            <OrganizationDiv>{this.props.organization}</OrganizationDiv>
          </ImgContainer>
        )}

        <div
          style={{
            display: 'flex',
            flex: '0 0 20%',
            marginRight:
              this.props.type === typeToList.PERSONS ? '0' : '-11.2em',
          }}
        >
          {this.props.canChangePermission && !this.props.disabled && (
            <Popover
              style={{ padding: '.5em' }}
              isDefaultOpen={false}
              position={'bottom-start'}
              isOpen={this.state.isPermissionPopoverOpen}
              usePortal={false}
              // target={(<div>Hello</div>)}
              renderTarget={ref => (
                <PermissionCont
                  onBlur={onBlur}
                  canChangePermission={this.props.canChangePermission}
                  ref={ref}
                  onClick={() => {
                    this.setState({
                      isPermissionPopoverOpen: !this.state
                        .isPermissionPopoverOpen,
                    });
                  }}
                >
                  {this.props.permissionLevel.name}
                  <MunikumIcons.ArrowDown
                    style={{ marginLeft: '.1em', marginBottom: '-.1em' }}
                  />
                </PermissionCont>
              )}
            >
              <div>
                {permissionList.map((c, i) => {
                  const isActive = this.state.currentIndex === i;
                  return (
                    <PermissionList
                      isActive={isActive}
                      key={i}
                      onMouseEnter={() => {
                        this.setState({
                          currentIndex: i,
                        });
                      }}
                      onMouseLeave={() => {
                        this.setState({
                          currentIndex: -1,
                        });
                      }}
                      onClick={() => {
                        safeInvoke(this.props.onChangeSelected, c.value);
                        this.setState({
                          isPermissionPopoverOpen: false,
                          currentIndex: -1,
                        });
                      }}
                    >
                      {c.name}
                    </PermissionList>
                  );
                })}
              </div>
            </Popover>
          )}
          {!this.props.canChangePermission && (
            <PermissionCont
              canChangePermission={this.props.canChangePermission}
            >
              {this.props.permissionLevel.name}
            </PermissionCont>
          )}
        </div>

        <div
          style={{
            flex: '0 0 15%',
            display: 'flex',
            alignItems: 'center',
            justifyContent:
              this.props.type === typeToList.PERSONS ? 'flex-start' : 'center',
          }}
        >
          {this.props.canRemove && !this.props.disabled && (
            <RemoveDiv
              style={{
                color: 'rgb(242, 169, 0)',
                marginRight:
                  this.props.type === typeToList.PERSONS ? '0' : '.4em',
              }}
              canRemove={this.props.canRemove}
              onClick={() => {
                safeInvoke(this.props.handleRemoveMember);
              }}
            >
              <MunikumIcons.Cancel
                style={{
                  height: '1.2em',
                  width: '1.2em',
                  color: Colors.YELLOW,
                }}
              />
            </RemoveDiv>
          )}
          {!this.props.canRemove && <div style={{ marginLeft: '1.6em' }} />}
        </div>
      </MemmbersContainer>
    );
  }
}

export const MembersOfAnnualCycleCard = injectIntl(
  MembersOfAnnualCycleCardComp
);
MembersOfAnnualCycleCard.defaultProps = {
  disabled: false,
};

interface IMembersOfAnnualCycleCardEveryoneComp {
  onCancelClick?: () => void;
  style?: CSSProperties;
  disabled?: boolean;
}

export function MembersOfAnnualCycleCardEveryoneComp(
  props: IMembersOfAnnualCycleCardEveryoneComp
) {
  return (
    <MemmbersContainer style={props.style}>
      <ImgContainer>
        <MunikumIcons.Globe
          style={{ width: '1.875em', height: '1.875em', color: '#FF5C39' }}
        />
        <NameDiv>Alle</NameDiv>
      </ImgContainer>
      <TextVerySmall
        style={{
          display: 'flex',
          alignItems: 'center',
          minWidth: '2em',
          marginRight: '-11.4em',
        }}
      >
        Lesetilgang
      </TextVerySmall>
      {!props.disabled && (
        <RemoveDiv
          style={{ marginRight: '1.45em' }}
          canRemove={true}
          onClick={() => {
            safeInvoke(props.onCancelClick);
          }}
        >
          <MunikumIcons.Cancel
            style={{
              height: '1.2em',
              width: '1.2em',
              color: 'rgb(242, 169, 0)',
            }}
          />
        </RemoveDiv>
      )}
    </MemmbersContainer>
  );
}

MembersOfAnnualCycleCardEveryoneComp.defaultProps = {
  disabled: false,
};

function CreateSharableUriCardComp(
  props: IMembersOfAnnualCycleCardEveryoneComp & {
    isThereUri: boolean;
    uri?: string;
    id: string;
    handleErrorChange?: (state: boolean) => void;
  } & InjectedIntlProps
) {
  let toastRef: React.RefObject<Toaster> = null;
  const [uri, setUri] = React.useState(props.uri);
  const [isThereUri, setisThereUri] = React.useState(props.isThereUri);
  const [isOverlayOpen, setIsOverlayOpen] = React.useState(false);
  const [showErrorMssg, setShowErrorMssg] = React.useState(false);

  function copy() {
    try {
      if (toastRef.current) {
        let el: any = document.createElement('textarea');
        el.value = CALENDAR_SHARE_HOST + uri;
        el.setAttribute('readonly', '');
        el.style = { position: 'absolute', left: '-9999px' };
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');

        toastRef.current.addToast({
          message: (
            <FlexDiv
              style={{
                justifyContent: 'center',
                width: '8em',
                height: '1em',
                marginRight: '1em',
              }}
            >
              <TextNormal style={{ color: Colors.WHITE }}>Kopiert!</TextNormal>
            </FlexDiv>
          ),
          timeout: 3000,
          theme: ToastType.SUCCESS_BLUE,
        });
      }
    } catch (e) {
    }
  }

  toastRef = React.createRef();

  return (
    <SharableUriCont
      onClick={() => {
        if (!isThereUri) {
          setIsOverlayOpen(true);
        }
      }}
      isEditing={isThereUri}
      style={{ ...props.style }}
    >
      <Toaster ref={toastRef} theme={ToastType.WHITE} />
      <FlexDiv>
        <MunikumIcons.Link
          style={{
            marginRight: '.6em',
            width: '1.5em',
            height: '1.5em',
            color: '#FF5C39',
          }}
        />
        {isThereUri ? (
          <Temp
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '22em',
            }}
          >
            <a
              target={'_blank'}
              href={CALENDAR_SHARE_HOST + uri}
              style={{
                color: Colors.RED,
                margin: '1px',
                border: 'none',
              }}
            >
              {CALENDAR_SHARE_HOST + uri}
            </a>
          </Temp>
        ) : (
          <TextSmall>
            {props.intl.formatMessage(commonMessages.createLinkToShare)}
          </TextSmall>
        )}
      </FlexDiv>
      {isThereUri && (
        <FlexDiv>
          <CopyDiv
            style={{ marginRight: '2.5em' }}
            onClick={() => {
              copy();
            }}
          >
            <TextVerySmall style={{ marginRight: '.25em' }}>
              {props.intl.formatMessage(commonMessages.copy)}
            </TextVerySmall>
            <MunikumIcons.copy style={{ width: '1em', height: '1em' }} />
          </CopyDiv>
          <IconDiv
            onClick={() => {
              myApolloClient
                .mutate({
                  mutation: REMOVE_SHARABLE,
                  variables: {
                    id: props.id,
                  },
                })
                .then(c => {
                  setisThereUri(false);
                  setUri('');
                });
            }}
          >
            <MunikumIcons.Cancel
              style={{
                height: '1.6em',
                width: '1.6em',
                marginRight: '1.9em',
                color: 'rgb(242, 169, 0)',
              }}
            />
          </IconDiv>
        </FlexDiv>
      )}

      <CleanDialog
        canEscapeKeyClose={false} // TODO: doesnt work with contenteditable.. fix? also doesnt work when trying to cancel event bubbling . . .
        canOutsideClickClose={true}
        showCloseWarning={CloseWarningOption.SIMPLE}
        isOpen={isOverlayOpen}
        onClose={() => setIsOverlayOpen(false)}
      >
        <OverlayDiv>
          <FlexDiv style={{ justifyContent: 'space-between' }}>
            <H3>{props.intl.formatMessage(commonMessages.createLink)}</H3>
            {/*<Tooltip usePortal={true} content={'Tekst her'}>*/}
            {/*<MunikumIcons.Help style={{color: Colors.YELLOW}}/>*/}
            {/*</Tooltip>*/}
          </FlexDiv>
          <div>
            <Input
              placeholder={props.intl.formatMessage(
                commonMessages.writeTitleForLink
              )}
              value={uri}
              onChange={e => {
                setUri(e.target.value.trim().toLowerCase());
                if (showErrorMssg) {
                  setShowErrorMssg(false);
                }
              }}
              style={{ width: '100%' }}
            />
            <TextVerySmall
              style={{
                marginLeft: '.25em',
                marginTop: '.5em',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                opacity: '.5',
              }}
            >
              {CALENDAR_SHARE_HOST + uri}
            </TextVerySmall>
            {showErrorMssg && (
              <FormErrorMessage>
                {props.intl.formatMessage(commonMessages.linkIsOccupied)}
              </FormErrorMessage>
            )}
          </div>

          <FlexDiv style={{ justifyContent: 'flex-end' }}>
            <Button
              greyBackground={true}
              onClick={() => {
                setIsOverlayOpen(false);
                setUri('');
              }}
              text={'Avbryt'}
              style={{ marginRight: '.5em' }}
            />
            <Button
              greyBackground={true}
              buttonTheme={ButtonTheme.RED}
              onClick={() => {
                myApolloClient
                  .mutate({
                    mutation: MAKE_SHARABLE,
                    variables: {
                      input: {
                        id: props.id,
                        uri: uri,
                      },
                    },
                  })
                  .then(c => {
                    if (c.data.makeSharable === null) {
                      setShowErrorMssg(true);
                    } else {
                      setIsOverlayOpen(false);
                      setisThereUri(true);
                    }
                  })
                  .catch(e => {
                  });
              }}
              text={'Opprett'}
            />
          </FlexDiv>
        </OverlayDiv>
      </CleanDialog>
    </SharableUriCont>
  );
}

MembersOfAnnualCycleCardEveryoneComp.defaultProps = {
  disabled: false,
};

export const CreateSharableUriCard = injectIntl(CreateSharableUriCardComp);
